import { Injectable } from '@angular/core';
import { HttpContext } from '@angular/common/http';
import { ApiService } from '@core/services/api.service';
import { SKIP_GLOBAL_ERROR_SNACKBAR } from '@core/interceptors/http-error.interceptor';
import { Observable } from 'rxjs';
import {
  LoginModel,
  AuthInfo,
  UpdatePasswordModel,
  FirstTimeResetPasswordModel,
  PermissionModel,
} from '../../authorization/models';

/**
 * The unauthenticated pages render their own inline banner, so the global snackbar would
 * double up on the same failure — and it shows the raw (English-only) backend detail.
 */
const inlineFeedbackOnly = (): { context: HttpContext } => ({
  context: new HttpContext().set(SKIP_GLOBAL_ERROR_SNACKBAR, true),
});

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private readonly apiService: ApiService) {}

  login(payload: LoginModel): Observable<AuthInfo> {
    return this.apiService.postRaw('/users/me/login', payload as any, inlineFeedbackOnly());
  }

  resetPassword(payload: FirstTimeResetPasswordModel): Observable<any> {
    return this.apiService.postRaw(`/users/password/reset`, payload, inlineFeedbackOnly());
  }

  updatePassword(payload: UpdatePasswordModel): Observable<any> {
    return this.apiService.post(`/users/me/password/reset`, payload);
  }

  sendLinkResetPasswordToEmail(user_email: string): Observable<any> {
    return this.apiService.postRaw(
      `/users/me/password/reset/request`,
      { user_email },
      inlineFeedbackOnly(),
    );
  }

  logout(id_token: string): Observable<any> {
    return this.apiService.post('/users/me/logout', { id_token });
  }

  getRefreshToken(refresh_token: string): Observable<AuthInfo> {
    return this.apiService.post('/users/me/token/refresh', { refresh_token });
  }

  getUserPermissions(oid: string): Observable<PermissionModel[]> {
    return this.apiService.get(`/users/${oid}/permissions`);
  }

  joinNetwork(token: string): Observable<any> {
    return this.apiService.postRaw('/users/joinnetwork', { token: token }, inlineFeedbackOnly());
  }
}
